// extracted by mini-css-extract-plugin
export default {"list":"style_list__2laSw","row":"style_row__9jTRO"};